import setRef from '@mui/utils/setRef';

export default setRef;
